import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.funktionsbereiche-pruefplaene-admin';
import * as api from '../../../clients/qschecks';

@Injectable()
export class QschecksFunktionsbereichePruefplaeneAdminEffects {

    FunktionsbereichePruefplaeneAdmin$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_FUNKTIONSBEREICHE_PRUEFPLAENE_ADMIN),
        mergeMap((x: ac.GetFunktionsbereichePruefplaeneAdminAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getFunktionsbereichePruefplaeneAdmin().pipe(
                map((result: any) => {
                    return new ac.GetFunktionsbereichePruefplaeneAdminErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetFunktionsbereichePruefplaeneAdminFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AdminQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AdminQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.AdminQueryService);
        }
        return this.service;
    }
}
